import httpVerify from "../axios/http-site-status";

class SiteStatus {
  constructor() {
    this.getSiteStatus = "/get-settings";
  }

  async fetchSiteStatus() {
    return httpVerify.get(`${this.getSiteStatus}`).catch((err) => {
      // handle error if needed
      throw err;
    });
  }
}
export default new SiteStatus();
